import { PropsWithChildren } from "react";

import { Backdrop } from "@mui/material";

export function FullScreenBackdrop(props: PropsWithChildren) {
  return (
    <Backdrop
      open
      sx={{
        color: (theme) => theme.palette.primary.main,
        zIndex: (theme) => theme.zIndex.modal + 1,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
      }}
    >
      {props.children}
    </Backdrop>
  );
}
